import {
  HomeIcon,
  ChartBarIcon,
  DocumentPlusIcon,
  ArchiveBoxIcon,
  MegaphoneIcon,
  Cog6ToothIcon,
  EnvelopeIcon,
  ClipboardDocumentIcon,
  InboxIcon,
} from "@heroicons/react/24/outline";
import { NavigationItem } from "./types";

const navigation: NavigationItem[] = [
  {
    name: "My Chapter",
    href: "/",
    icon: HomeIcon,
    current: false,
    internalName: "home",
    roles: ["ROLE_OFFICER", "ROLE_ADVISOR"],
  },
  {
    name: "Activity Reports",
    href: "#",
    icon: ChartBarIcon,
    current: false,
    internalName: "activity_reports",
    roles: ["ROLE_OFFICER", "ROLE_ADVISOR"],
    children: [
      {
        name: "New Report",
        href: "/submit-activity", // We'd need to create this component
        icon: DocumentPlusIcon,
        current: false,
        internalName: "new_report",
        roles: ["ROLE_OFFICER", "ROLE_ADVISOR"],
      },
      {
        name: "View Activity Reports",
        href: "/chapter-activities", // Our new route
        icon: ClipboardDocumentIcon,
        current: false,
        internalName: "chapter_activities",
        roles: ["ROLE_OFFICER", "ROLE_ADVISOR"],
      },
    ],
  },
  {
    name: "Notify Members",
    href: "#", // Changed to dropdown
    icon: MegaphoneIcon,
    current: false,
    internalName: "notify_members",
    roles: ["ROLE_OFFICER", "ROLE_ADVISOR"],
    children: [
      {
        name: "New Notification",
        href: "/create-notification", // Would need to create this component
        icon: DocumentPlusIcon,
        current: false,
        internalName: "new_notification",
        roles: ["ROLE_OFFICER", "ROLE_ADVISOR"],
      },
      {
        name: "My Notifications",
        href: "/my-email-notifications", // Our new route
        icon: InboxIcon,
        current: false,
        internalName: "my_notifications",
        roles: ["ROLE_OFFICER", "ROLE_ADVISOR"],
      },
    ],
  },
  {
    name: "Admin",
    href: "#",
    icon: Cog6ToothIcon,
    current: false,
    internalName: "admin_dropdown",
    roles: ["ROLE_ADMIN"],
    children: [
      {
        name: "Email Notifications",
        href: "/admin/email-notifications",
        icon: EnvelopeIcon,
        current: false,
        internalName: "email_notifications",
        roles: ["ROLE_ADMIN"],
      },
    ],
  },
];

const hubConfig = {
  sectionName: "hub",
  defaultRoute: "/hub",
  navigation,
};

export default hubConfig;
